/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:42:03
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare بکەوە",
    name2: "ڕێزێرڤێک ئەنجام بدە",
    name3: "لەڕێگەی Carlcare، دەتوانی هەموو کاتێک داواکارییەکەت بپشکنی.",
    name4: "",
    name5: "بیخزێنە بۆلای ڕاست",
    name6: "پشتڕاستکردنەوە کۆتایی پێهات",
        name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02150880282.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
        name40: "Exclusive for",
    name41: "Jakarta Pusat!",
    name42: "Reservation Now",
    name43: "What is Carlcare Home Service ?",
    name44: "1.Carlcare Home Service is available for TECNO, Infinix, and itel users.",
    name45: "2.Enjoy convenient and efficient repair services anywhere (at home, in the office, at a café, on campus, or outdoors), saving you time and effort.",
    name46: "Why do we recommend choosing Carlcare Home Service ?",
    name47: "Free Home Service Charges",
    name48: "No home service fees required.",
    name49: "*For out of warranty or accidental damage, pay for parts and labor.",
    name50: "Easy Booking",
    name51: "Easily book through Carlcare App, website, hotline, or WhatsApp.",
    name52: "Safe & Reliable",
    name53: "With strict safety measures, ensuring your device is in trusted hands.",
    name54: "Official Support",
    name55: "All repairs by Carlcare official engineers use only original spareparts.",
    name56: "Ways to Book Carlcare Home Service",
    name57: "1. Open the Carlcare App",
    name58: '2. Tap "Reservation"',
    name59: '3. Choose "Carlcare Home Service"',
    name60: "4. Select your current location",
    name61: "5. Fill in the required details to complete the reservation",
    name62: "1. Open the Carlcare Official Website:https://www.carlcare.com/id/",
    name63: '2. Tap "Perbaiki Telepon"',
    name64: '3. Choose "Carlcare Home Service"',
    name65: "4. Select your current location",
    name66: "5. Fill in the required details to complete the reservation",
    name67: "Call Carlcare hotline: 021 5088 0282 to book Carlcare Home Service.",
    name68: "Contact Carlcare WhatsApp Business Account:+62-812-9009-0559 to Carlcare Home Service.",
    name69: "1.Device needs repair.",
    name70: "2.Book Carlcare Home Service.",
    name71: "3.Engineer contacts you to confirm the appointment time.",
    name72: "4.Engineer arrives at the scheduled time.",
    name73: "5.Complete the repair and make the payment.",
    name74: "Statement:",
    name75: "1.Free Home Service applies to service fees only. ",
    name76: "①Under Warranty: Enjoy free home service and repairs;",
    name77: "②Out of Warranty:Only pay for labor and spareparts,no extra home service charges.",
    name78: "2.Carlcare Home Service is currently limited to the the Jakarta Pusat and will gradually expand to more regions in the future. Please Stay tuned!",
    name79: "3.The final explanation of the activity belongs to Carlcare.",
    name80: "Carlcare App",
    name81: "Carlcare Website",
    name82: "Carlcare Hotline",
    name83: "Carlcare WhatsApp",
    name84: "No door-to-door fee",
    name85: "Service Process:",
  },
  order: {
    name1: "مۆدێلی ئامێر هەڵبژێرە",
    name2: "شی کردنەوەی کێشە:",
    name3: "بۆ هەڵبژاردنی فرۆشگای خزمەتگوزاری کرتە بکە",
    name4: "فرۆشگای خزمەتگوزاری:",
    name5: "کاتی ڕێزێرف کردن:",
    name6: "تکایە بە وردەکارییەوە باسی گرفتی ئامێرەکەت بکە!",
    name7: "بۆ هەڵبژاردنی کاتی گەیشتن کرتە بکە",
    name8: "تکایە زانیاریی پەیوەندیییەکەت دروست بنووسە بۆ ئەوەی بتوانین پەیوەندیت پێوە بکەین",
    name9: "کاتی ڕێزێرف کردنی بەردەست بەم سێوەیەی خوارەوەیە",
    name10: "تکایە ژمارە مۆبایلەکەت بنووسە",
    name11: "نرخ",
    name12: "زانیارییە تاکەکەسییەکان:",
    name13: "تکایە ناوت بنووسە",
    name14: "ناردن",
    name15: "هەڵوەشاندنەوە",
    name16: "باشە",
  },
  shops: {
    name1: "لە سەر بنەمای ئەو بڕەندەی هەڵیدەبژێری، ئەم گرۆشگایانەی خوارەوە دەتوانن خزمەتت بکەن!",
    name2: "بەم زوویانە دووکانی فرۆشتنی زیاتر دێن! لە گەڵمان بمێنەوە!",
  },
  price: {
    name1: "بڕەند",
    name2: "مۆدێل",
    name3: "بڕگە",
    name4: "نرخ",
    name5: "وەبیرهێنەرەوەی هاوڕێیانە:",
    name6: "ئەم نرخانە تەنیا بۆ ژێدەرن، و نرخی ڕاستەقینەکە پەیوەندیی بە بارودۆخی ئامێرەکەت هەیە.",
    name7: "ئەگەر هیچ هێمایەکی تایبەتی نەبێت، یەکەی نرخەکە یەکەی دراوی خۆجێیە.",
    name8: "بەداخەوەین! لەم هەرێمەی ئێستاد هیچ زانیارییەکی نرخ لەبەردەستدا نییە.",
    name11:"تێچووی کرێکاران",
    name12:"نرخی گشتی",
    name13: "٥. ئەگەر تێچووی کار \"/\" بێت، بەواتای ئەمەیە کە تێچووی کار پێویستی بە ڕاوێژکردنە لەگەڵ فرۆشگاکە.",
    item_main_board: "مادربۆرد",
    item_screen_frame: "شاشە (چوارچێوە)",
    item_screen_screen_frame: "شاشەی لاوەکی (چوارچێوە)",
    item_touch_screen: "شاشەی تاچ سکرین",
    item_camera: "کامێرا",
    item_fixed_focus_camera: "کامێرای فۆکەسی نەگۆڕ",
    item_auto_focus_camera: "کامێرای فۆکەسی ئۆتۆماتیکی",
    item_screen: "شاشە",
    item_secondary_screen: "شاشەی دووەم",
    item_fingerprint_module: "مۆدیۆلی پەنجەمۆر",
    item_speaker: "بڵندگۆ",
    item_receiver: "وەرگر",
    item_small_board: "بۆردی بچووک",
    item_battery_cover: "کەڤەری پاتری",
    item_battery: "پاتری",
    item_charger: "بارگاویکەر",
    item_usb_cable: "وایەری USB",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "هیچ زانیارییەکی تێدا نییە",
    name2: "دابینکاریی خزمەتگوزاری:",
    name3: "بڕەندی خزمەتگوزاری:",
    name4: "تەلەفۆن:",
    name5: "کواڵیتی داواکاری:",
    name6: "پلەبەندیی خزمەتگوزاری",
    name7: "ژینگەی خزمەتگوزاری:",
    name8: "تێڕوانینی خزمەتگوزاری:",
    name9: "لێهاتوویی خزمەتگوزاریی:",
    name10: "کوالیتیی خزمەتگوزاری:",
    name11: "هەڵسەنگاندنی مشتەری",
    name12:"بۆ",
    name13:"داخرا",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare بکەوە",
    name1: "تکایە سکرین شاتێک لە زانیارییەکانی رێزێرفەکەت بگرە و وەک ڕەسیدێک پاشەکەوتی بکە بۆ دەستڕاگەیشتنی خزمەتگوزاریی لەپێشترێتی.",
    name2: "سەرکەوتووانە پێشکەش کرا",
    name3: "١. دێیتاکان بسڕەوە",
    name4: "تکایە لەپێشتردا دێیتا تایبەتییە گرینگەکانی مۆبایلەکەت بگەڕێنەوە",
    name5: "٢. قفڵی هەڵکردن بە تێپەڕوشە ناچالاک بکە",
    name6: "پێش ئەوەی بچییە فرۆشگای فرۆشتن، تکایە:",
    name7: "فرۆشگای خزمەتگوزاری:",
    name8: "کاتی ڕێزێرف کردن:",
    name9: "شی کردنەوەی کێشە:",
    name10: "مۆدێلی ئامێر:",
    name11: "ژمارەی فرمان:",
    name12: "پۆلێنی زانیارییەکان",
  },
  title: {
    name1: "پشتیوانی لەم وڵاتانەی خوارەوە دەکات:",
    name2: "هەڵبژاردنی مۆدێل",
    name3: "ڕێزێرڤ",
    name4: "وەردەکارییەکانی فرۆشگای خزمەتگوزاری",
    name5: "فرۆشگای خامتگوزاری هەڵبژێرە",
  },
  error: {
    name1: "هیچ زانیارییەکی تێدا نییە. تکایە زانیارییەکانی چاککردنەوەت بپشکنە",
    name2: "پێویستیت بە یارمەتیی زیاتر هەیە؟ تکایە پەیوەندیمان پێوە بکە.",
    name3: "ببوورە، لەم هەرێمەی ئێستادا هیچ ناوەندێکی Carlcare نییە.",
    name4: "تکایە سەرەتا ناوەندێکی خزمەتگوزاری هەڵبژێرە",
    name5: "شکستهێنان",
    name6: "تکایە سەرتا مۆدێلی ئامێر هەڵبژێرە",
    name7: "وردەکاری",
    name8: "تکایە پێداویستییەکانت بە وردی شی بکەوە",
    name9: "",
  },
  add1:{
    "name0": "ckb-rIQ",
    "name1": "داواکارییەکەت پشتڕاست کراوەتەوە. چاوەڕوانی هاتنت دەکەین.",
    "name2": "دەستنیشانکردنی شار",
    "name3": "تکایە ژمارەیەکی مۆبایل بنووسە %1$s لە ژمارەکان.",
    "name4": "کاتژمێرەکانی ڕۆژانی هەفتە",
    "name5": "دووشەممە",
    "name6": "سێ شەممە",
    "name7": "چوارشەممە",
    "name8": "پێنجشەممە",
    "name9": "هەینی",
    "name10": "شەممە",
    "name11": "یەک شەممە",
    "name12": "وڵات بنووسە و بگەڕێ"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "Pick-up Time",
    "name7": "Tap to select pick-up time",
    "name8": "Pick-up Address",
    "name9": "Please input your house number/street/district/province",
    "name10": "Please input your postal code",
    "name11": "Add returning address",
    "name12": "Returning Address",
    "name13": "ئەوانی دیکە",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"بۆ گۆڕینی ئاراستەکە دایگرە",
    name3:"بۆ هەڵسەنگاندنی داواکارییەکە ئەپلیکەیشنی Carlcare بکەوە",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"خزمەتگوزاری هەڵبژێرە",
    name7:"پاککردنەوەی بێ بەرامبەر",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "زانیاری هەڵە",
    "cancelReason1": "لە کاتی خۆیدا ناگاتێ",
    "cancelReason2": "داواکاری دوبارە/ داواکاری من نییە",
    "cancelReason3": "هەڵە دووبارە نابێتەوە",
    "cancelReason4": "تەنیا بۆ تاقیکردنەوە/ پرسیار/ڕووداو/…",
    "cancelReason5": "نرخی بەرز",
    "cancelReason6": "کەمیی مەتریاڵ",
    "cancelReason7": "خزمەتگوزاری جیاواز نییە",
    "cancelReason8": "ئەم فرۆشگایە زۆر دوورە",
    "cancelReason9": "فرۆشگاکە داخراوە",
    "cancelReason10": "حاڵەتی خزمەتگوزاری هەڵە",
    "cancelReason11": "گۆڕین/چاککردنەوەی پەیوەست بە براندەکانی تر",
    "cancelReason12": "دۆزینەوەی فرۆشگا مومکین نییە",
    "cancelReason13": "ئەوانی دیکە",
    "cancelOrder": "هەڵوەشاندنەوەی فرمان",
    "reason_dialog_title": "تکایە هۆکاری هەوڵوەشانەوەمان پێ بڵێ",
    "Cancel": "هەڵوەشاندنەوە",
    "OK": "باشە",
    "name1": "کۆدی گۆڕین بنووسە",
    "name2": "کۆدی پشتڕاستکردنەوەی چەوت",
    "repair_reservation_detail_canceled": "ئەم داواکارییە هەڵوەشێندراوەتەوە!",
    "purchase_cancel_dialog_content": "ئایا هەڵوەشاندنەوەی داواکارییەکە پشتڕاست دەکەیەوە؟",
    "yes": "بەڵێ",
    "no": "نا"
}
};
